import React, { FC, useState } from 'react';
import styled from '@emotion/styled';
import Card from '@app/components/card/Card';
import { ModalCloseButton } from '@app/components/Modal';
import Button from '@app/components/Button';
import NakedCalendarDatePicker from '@app/components/inputs/NakedCalendarDatePicker';
import InputBox from '@app/components/inputs/inputBox/InputBox';
import { BodyRegularStartTransparentBlack600 } from '@app/components/Text';

interface Props {
  onDone: (minTimestamp: number | null) => void;
}

const SendRecordsReportModal: FC<Props> = ({ onDone }) => {
  const [selectedDate, setSelectedDate] = useState<number | undefined>(undefined);

  const handleSend = (): void => {
    if (!selectedDate) {
      return;
    }
    onDone(selectedDate);
  };

  const handleCancel = (): void => {
    onDone(null);
  };

  const handleDateChange = (newValue: number | undefined): void => {
    setSelectedDate(newValue);
  };

  return (
    <ModalContainer>
      <ModalHeader>
        <ModalTitle>Send Records Report</ModalTitle>
        <ModalCloseButton onDone={handleCancel} />
      </ModalHeader>
      <ModalContent>
        <Description>
          Select a minimum date to filter records. Only records created from this date onwards will be included in the report.
        </Description>
        <InputBox>
          <NakedCalendarDatePicker
            id='records-report-date-picker'
            accessibilityLabel='Select minimum date for records'
            value={selectedDate as any}
            onChange={handleDateChange as any}
            placeholder='Select date *'
            placeholderStyle='onlyWhenEmpty'
            disableFutureDates={true}
          />
        </InputBox>
        <ButtonsContainer>
          <Button id='btn-cancel-send-records-report' appearance='outline' onClick={handleCancel}>
            Cancel
          </Button>
          <Button id='btn-confirm-send-records-report' onClick={handleSend} disabled={!selectedDate}>
            Send Report
          </Button>
        </ButtonsContainer>
      </ModalContent>
    </ModalContainer>
  );
};

export default SendRecordsReportModal;

const ModalContainer = styled(Card)`
  padding: 25px;
  width: 450px;
`;

const ModalHeader = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 20px;
  display: flex;
  flex-direction: row;
`;

const ModalTitle = styled.div`
  flex: 1;
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Description = styled(BodyRegularStartTransparentBlack600.div)`
  margin-bottom: 5px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 10px;
`;
